<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-envelope text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.CREATE_MASC.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.CREATE_MASC.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div *ngIf="visibleTabs().length > 1" class="tab-nav tab-nav--centered w-full">
         <button
            *ngFor="let tab of visibleTabs()"
            type="button"
            class="tab-nav__item"
            [class.tab-nav__item--active]="activeTab() === tab.value"
            (click)="activeTab.set(tab.value)"
         >
            <lucide-icon *ngIf="tab.value === 'preview'" name="eye" [size]="15"></lucide-icon>
            <lucide-icon *ngIf="tab.value === 'config'" name="settings" [size]="15"></lucide-icon>
            <span>{{ tab.label }}</span>
         </button>
      </div>
   </div>

   <!-- Preview tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <div class="flex justify-content-center">
            <div
               class="email-mockup shadow-4 border-round-xl bg-white overflow-hidden flex flex-column w-full max-w-30rem"
            >
               <div class="email-header bg-gray-100 p-3 border-bottom-1 border-200">
                  <div class="flex flex-column gap-2">
                     <div class="flex justify-content-between align-items-center">
                        <span class="text-xs font-bold text-700"
                           >{{ 'DATA.MODULES.INSPECTORS.CREATE_MASC.PREVIEW.SENDER_LABEL' | translate }}: Paymefy</span
                        >
                        <span class="text-xs text-500">10:45 AM</span>
                     </div>
                     <span *ngIf="this.replyToEmailAddresses().length > 0" class="text-xs font-bold text-700"
                        >Reply-to: {{ this.replyToEmailAddresses() }}</span
                     >
                     <div class="text-sm font-semibold text-800">
                        {{ 'DATA.MODULES.INSPECTORS.CREATE_MASC.PREVIEW.SUBJECT_LABEL' | translate }}:
                        {{ previewSubject() || '...' }}
                     </div>
                  </div>
               </div>

               <div class="email-content p-4 bg-white flex-grow-1 overflow-y-auto min-h-15rem">
                  <div
                     *ngIf="previewMessage()"
                     class="text-sm text-700 line-height-3"
                     [innerHTML]="previewMessage()"
                  ></div>

                  <div
                     *ngIf="!previewMessage()"
                     class="flex flex-column align-items-center justify-content-center h-full text-400 opacity-60 italic py-5"
                  >
                     <i class="pi pi-envelope text-4xl mb-2"></i>
                     <span>{{ 'DATA.MODULES.INSPECTORS.CREATE_MASC.CONFIG.TEMPLATE_HELP' | translate }}</span>
                  </div>
               </div>

               <div class="email-footer bg-gray-50 p-3 border-top-1 border-200 text-center text-xs text-500">
                  Email certificado de Paymefy
               </div>
            </div>
         </div>

         <div class="flex flex-column gap-3">
            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
            >
               <div class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-envelope text-blue-700 text-lg"></i>
               </div>
               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.CREATE_MASC.PREVIEW.SELECTED_EMAIL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-blue-800">{{ selectedTemplateName() }}</span>
               </div>
            </div>

            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
            >
               <div class="bg-indigo-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-reply text-indigo-700 text-lg"></i>
               </div>
               <div class="flex flex-column gap-1 w-full">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.CREATE_MASC.PREVIEW.REPLY_TO_LABEL' | translate
                  }}</span>
                  <div class="flex flex-wrap gap-2">
                     <span
                        *ngFor="let email of replyToEmailAddresses()"
                        class="px-2 py-1 border-round bg-indigo-50 text-indigo-800 text-sm"
                        >{{ email }}</span
                     >
                     <span *ngIf="!replyToEmailAddresses().length" class="text-500 text-sm">{{
                        'DATA.MODULES.INSPECTORS.CREATE_MASC.PREVIEW.NO_REPLY_TO' | translate
                     }}</span>
                  </div>
               </div>
            </div>

            <div *ngIf="errors().length" class="mt-4">
               <div *ngFor="let e of errors()" class="text-red-600 text-sm">{{ e.errorMessage }}</div>
            </div>
         </div>
      </div>
   </div>

   <!-- Config tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <div class="flex flex-column gap-2">
            <label class="font-semibold text-800">{{
               'DATA.MODULES.INSPECTORS.CREATE_MASC.CONFIG.TEMPLATE_LABEL' | translate
            }}</label>
            <span class="text-500 text-sm mb-1">{{
               'DATA.MODULES.INSPECTORS.CREATE_MASC.CONFIG.TEMPLATE_HELP' | translate
            }}</span>
            <p-dropdown
               [options]="templates()"
               [ngModel]="selectedTemplateId()"
               (ngModelChange)="onTemplateChange($event)"
               optionLabel="name"
               optionValue="id"
               placeholder="Selecciona una plantilla"
               styleClass="w-full"
               [filter]="true"
            ></p-dropdown>

            <div *ngIf="editTemplateUrl()" class="flex justify-content-end mt-1">
               <a
                  [href]="editTemplateUrl()"
                  target="_blank"
                  class="text-xs text-blue-600 hover:text-blue-800 font-medium no-underline flex align-items-center gap-1"
               >
                  <i class="pi pi-external-link"></i>
                  {{ 'DATA.MODULES.INSPECTORS.CREATE_MASC.CONFIG.EDIT_TEMPLATE' | translate }}
               </a>
            </div>
         </div>

         <div *ngIf="previewMessage()" class="mt-1">
            <div class="bg-blue-50 p-3 border-round-lg border-1 border-blue-200">
               <div class="font-semibold text-700 mb-2 flex align-items-center gap-2">
                  <i class="pi pi-align-left"></i>
                  {{ selectedTemplateName() }}
               </div>
               <div class="text-xs font-semibold text-600 mb-1">
                  {{ 'DATA.MODULES.INSPECTORS.CREATE_MASC.PREVIEW.SUBJECT_LABEL' | translate }}: {{ previewSubject() }}
               </div>
               <div
                  class="text-700 line-height-3 whitespace-pre-wrap text-sm max-h-10rem overflow-y-auto"
                  [innerHTML]="previewMessage()"
               ></div>
            </div>
         </div>

         <p-divider></p-divider>

         <div class="flex flex-column gap-2">
            <label class="font-semibold text-800">{{
               'DATA.MODULES.INSPECTORS.CREATE_MASC.CONFIG.REPLY_TO_LABEL' | translate
            }}</label>
            <span class="text-500 text-sm mb-1">{{
               'DATA.MODULES.INSPECTORS.CREATE_MASC.CONFIG.REPLY_TO_HELP' | translate
            }}</span>
            <p-chips
               [ngModel]="replyToEmailAddresses()"
               (ngModelChange)="onReplyToChange($event)"
               placeholder="email@example.com"
               separator=","
               [allowDuplicate]="false"
               styleClass="w-full"
               class="w-full"
            ></p-chips>
         </div>

         <div *ngIf="errors().length">
            <div *ngFor="let e of errors()" class="text-red-600 text-sm">{{ e.errorMessage }}</div>
         </div>
      </div>
   </div>
</div>
